// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__pk6y9","separatorText":"Separator_separatorText__p4CB-"};